export const surgicalEvaluation = {
	null: 'Brak',
	'1': 'Możliwy zabieg chirurgiczny',
	'2': 'Ponowna ocena resekcyjności po chemioter.',
	'3': 'Niemożliwy zabieg chirurgiczny',
	'4': 'Inna ocena',

}

export const chemotherapyEffectiveness = {
	null: 'Brak oceny',
	'1': 'Odpowiedź biochemiczna nie potwierdzona obrazowo',
	'2': 'Odpowiedź obrazowa',
	'3': 'Stabilizacja',
	'4': 'Progresja biochemiczna nie potwierdzona obrazowo',
	'5': 'Progresja obrazowa',
}

export const procedureRisk = {
	null: '-',
	'1': 'Radykalny R0',
	'2': 'Inna',
}

export default {
	surgicalEvaluation,
	chemotherapyEffectiveness,
	procedureRisk,
}
